module.exports = __webpack_public_path__ + "static/img/0001.815b6c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/0001.jpg
// module id = PvOS
// module chunks = 0